


  
  

  var faLinkEmbed = {
    prefix: 'fak',
    iconName: 'link-embed',
    icon: [
      512,
      512,
      [],
      'e00c',
      
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 32c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32zm32 96c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L96 224z'
      
    ]
  };

  

  
  

  var faLinkPill = {
    prefix: 'fak',
    iconName: 'link-pill',
    icon: [
      512,
      512,
      [],
      'e00b',
      
      'M0 224c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 352c-35.3 0-64-28.7-64-64l0-64zm48 32a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm176-32c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0z'
      
    ]
  };

  

  
  

  var faLinkText = {
    prefix: 'fak',
    iconName: 'link-text',
    icon: [
      512,
      512,
      [],
      'e00a',
      
      'M480 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32z'
      
    ]
  };

  

  
  

  var faPrivate = {
    prefix: 'fak',
    iconName: 'private',
    icon: [
      586,
      512,
      [],
      'e008',
      
      'M323.7 367l9.3-22.5 0 0L323.7 367zm-58.8 0l-9.3-22.5 0 0 9.3 22.5zM154.2 212.7L131.1 205c-2.5 7.4-1.2 15.6 3.4 22s11.9 10.1 19.8 10.1V212.7zM206.8 72.7l21.8 10.9 0 0L206.8 72.7zm52.5-35l17.2-17.2 0 0L259.3 37.6zm35 17.5l0 24.4 0 0 0-24.4zM434.4 212.7v24.4c7.8 0 15.2-3.8 19.8-10.1s5.8-14.5 3.4-22l-23.1 7.7zM381.9 72.7L360.1 83.6l0 0 21.8-10.9zm-52.5-35L312.1 20.4l0 0 17.2 17.2zM49.1 207.1c-13.5 0-24.4 10.9-24.4 24.4s10.9 24.4 24.4 24.4V207.1zm490.1 48.8c13.5 0 24.4-10.9 24.4-24.4s-10.9-24.4-24.4-24.4v48.8zM210.5 397.1c0 31.1-25.2 56.3-56.3 56.3v48.8c58 0 105.1-47 105.1-105.1H210.5zm-56.3 56.3c-31.1 0-56.3-25.2-56.3-56.3H49.2c0 58 47 105.1 105.1 105.1V453.4zM98 397.1c0-31.1 25.2-56.3 56.3-56.3V292.1c-58 0-105.1 47-105.1 105.1H98zm56.3-56.3c31.1 0 56.3 25.2 56.3 56.3h48.8c0-58-47-105.1-105.1-105.1v48.8zm336.4 56.3c0 31.1-25.2 56.3-56.3 56.3v48.8c58 0 105.1-47 105.1-105.1H490.7zm-56.3 56.3c-31.1 0-56.3-25.2-56.3-56.3H329.3c0 58 47 105.1 105.1 105.1V453.4zm-56.3-56.3c0-31.1 25.2-56.3 56.3-56.3V292.1c-58 0-105.1 47-105.1 105.1h48.8zm56.3-56.3c31.1 0 56.3 25.2 56.3 56.3h48.8c0-58-47-105.1-105.1-105.1v48.8zm-68.5 25.5c-9.4-9.4-20.6-16.8-32.8-21.9l-18.7 45c6.4 2.6 12.1 6.5 17 11.4l34.5-34.5zM333 344.4c-12.3-5.1-25.4-7.7-38.7-7.7v48.8c6.9 0 13.7 1.4 20.1 4L333 344.4zm-38.7-7.7c-13.3 0-26.5 2.6-38.7 7.7l18.6 45.1c6.4-2.6 13.2-4 20.1-4V336.7zm-38.7 7.7c-12.3 5.1-23.4 12.5-32.8 21.9l34.5 34.5c4.9-4.9 10.7-8.7 17-11.4l-18.7-45zm-78.2-124c11.9-35.6 38.1-110.8 51.2-136.9L185 61.8C170 91.7 142.6 170.6 131.1 205l46.3 15.4zM228.6 83.6c4.1-8.1 7.8-14.7 11.3-19.7c3.6-5.2 6.3-7.8 7.7-8.9c1.4-1 .1 .4-3 .2c-3.2-.2-4.1-1.8-2.6-.3l34.5-34.5c-7.2-7.2-16.9-13.2-28.9-13.9c-11.9-.7-21.9 3.9-29.3 9.5C204.7 26.2 193.9 44 185 61.8l43.6 21.8zm13.5-28.7c18.5 18.5 39.8 24.6 52.3 24.7l0-48.8c1 0-1.1 0-5-1.6c-3.6-1.5-8.2-4.2-12.7-8.8L242.1 54.9zM457.5 205C446 170.6 418.6 91.7 403.7 61.8L360.1 83.6c13.1 26.1 39.3 101.3 51.2 136.9L457.5 205zM403.7 61.8c-8.9-17.8-19.8-35.5-33.4-45.8c-7.4-5.5-17.4-10.2-29.3-9.5c-12 .7-21.6 6.7-28.9 13.9l34.5 34.5c1.5-1.5 .6 .1-2.6 .3c-3.2 .2-4.4-1.2-3-.2c1.5 1.1 4.1 3.7 7.7 8.9c3.5 5 7.3 11.6 11.3 19.7l43.6-21.8zM312.1 20.4c-4.6 4.6-9.2 7.3-12.7 8.8c-3.9 1.7-6 1.6-5 1.6l0 48.8c12.4 0 33.8-6.2 52.3-24.7L312.1 20.4zM49.1 255.9H539.1V207.1H49.1v48.8zm385.3-67.5H154.2v48.8H434.4V188.3z'
      
    ]
  };

  

  
  

  var faRecord = {
    prefix: 'fak',
    iconName: 'record',
    icon: [
      512,
      512,
      [],
      'e001',
      
      'M248 504A248 248 0 1 1 248 8a248 248 0 1 1 0 496zm0-48a200.1 200.1 0 1 0 .1-400.1A200.1 200.1 0 1 0 248 456zm.1-96.1A103.9 103.9 0 1 1 248 152a103.9 103.9 0 1 1 .1 207.9z'
      
    ]
  };

  

  
  

  var faRecordSlash = {
    prefix: 'fak',
    iconName: 'record-slash',
    icon: [
      512,
      512,
      [],
      'e006',
      
      'M353.5 421.4l-27.4-27.4c-21.1 10.7-45 16.8-70.2 16.8c-85.9 0-154.8-68.9-154.8-154.8c0-25.2 6-49.1 16.8-70.2L90.6 158.5C73.7 187 64 220.4 64 256c0 106.1 85.9 192 192 192c35.6 0 69-9.7 97.5-26.6zM158.5 90.6l27.3 27.3c21-10.7 44.9-16.8 70.2-16.8c85.2 0 154.8 69.7 154.8 154.8c0 25.3-6 49.2-16.8 70.2l27.3 27.3C438.3 325 448 291.6 448 256c0-106.1-85.9-192-192-192c-35.6 0-69 9.7-97.5 26.6zM348.8 280.9c2.1-7.9 3.2-16.3 3.2-24.9c0-52.6-43.4-96-96-96c-8.6 0-17 1.1-24.9 3.2L348.8 280.9zM163.3 231.1c-2.1 7.9-3.3 16.3-3.3 24.9c0 53.5 42.5 96 96 96c8.6 0 16.9-1.1 24.9-3.3L163.3 231.1zm267.9 200c6.2-6.2 6.2-16.4 0-22.6L103.5 80.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L408.5 431.1c6.2 6.2 16.4 6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faSalesforce = {
    prefix: 'fak',
    iconName: 'salesforce',
    icon: [
      683,
      512,
      [],
      'e007',
      
      'M284.2 52c22-22.9 52.7-37.1 86.5-37.1c45.2 0 84.3 25.1 105.4 62.5c18.7-8.4 39-12.7 59.5-12.7c81.3 0 147.3 66.5 147.3 148.5s-66 148.5-147.3 148.5c-9.9 0-19.6-1-29.1-2.9C488 391.7 452.8 414 412.7 414c-16.3 0-32.5-3.7-47.2-10.8c-18.7 43.9-62.2 74.8-112.9 74.8c-52.9 0-97.8-33.4-115.1-80.3c-7.7 1.6-15.6 2.4-23.4 2.4C51.1 400.1 .2 348.4 .2 285c0-42.6 22.9-79.8 56.9-99.8c-7.2-16.6-10.9-34.6-10.9-52.7C46.2 59.2 105.6 0 178.9 0c42.9 0 81.3 20.4 105.4 52.2z'
      
    ]
  };

  

  
  

  var faSalesforceOutline = {
    prefix: 'fak',
    iconName: 'salesforce-outline',
    icon: [
      512,
      512,
      [],
      'e009',
      
      'M468.2 242.4c0-49.7-36.9-87-79-87h0c-10.7 0-21.4 2.4-31.3 7.1l-19.1 9.1-9.8-18.7c-11.1-21.1-31.1-34.1-52.8-34.1c-16.4 0-31.7 7.3-43.1 20l-18.3 20.3-15.9-22.2c-12.9-18-32.7-29.1-54.5-29.1c-36.8 0-69 32.3-69 75.3v0c0 10.5 2 20.9 5.9 30.4l6.9 17-15.6 9.8C55.9 250.8 43.8 271 43.8 294.9c0 36.2 26.8 62.6 56.2 62.6l5.7-.3c1.9-.2 3.7-.5 5.6-.9l19.2-4.3 6.4 18.6c9.2 26.6 32.4 44.2 58.3 44.2c24.8 0 47.2-16.2 57.1-41.1l9-22.6 21.5 11.2c7 3.6 14.5 5.5 22.1 5.5h0l3.5-.1c17.3-1.3 32.8-12 41.5-28.6l7.7-14.8 16.3 3.5c4.9 1.1 10 1.6 15.3 1.6c42.1 0 79-37.4 79-87zm43.8 0c0 70.7-53.4 130.9-122.8 130.9c-3 0-6-.2-9-.4c-17.3 23.2-44.3 38.7-75.3 38.7c-7.4 0-14.7-.9-21.8-2.6c-18.8 29.5-50.8 49.6-88 49.6c-40.3 0-74.6-23.6-92.5-57.3l-2.5 .1C43.2 401.4 0 352.1 0 294.9c0-32.2 13.5-61.5 35.4-81.2c-2.5-10-3.8-20.3-3.8-30.7C31.6 118.7 80.8 64 144.4 64c28.6 0 54.5 11.2 74.2 29.4C235 81.8 254.7 75 276.1 75c33.1 0 62 16.4 81 41c10.4-3 21.2-4.5 32-4.5c69.4 0 122.8 60.2 122.8 130.9z'
      
    ]
  };

  

  
  

  var faSparklingBriefcase = {
    prefix: 'fak',
    iconName: 'sparkling-briefcase',
    icon: [
      672,
      512,
      [],
      'e004',
      
      'M428.3 160c24 0 44.3 20.3 44.3 44.3V440.6c0 24.9-20.3 44.3-44.3 44.3H44.3C19.4 484.9 0 465.5 0 440.6V204.3c0-24 19.4-44.3 44.3-44.3h73.8V115.7c0-24 19.4-44.3 44.3-44.3H310.2c24 0 44.3 20.3 44.3 44.3V160h73.8zM162.5 115.7V160H310.2V115.7H162.5zM49.8 204.3c-3.7 0-5.5 2.8-5.5 5.5v68.3h384V209.9c0-2.8-2.8-5.5-5.5-5.5H49.8zM422.8 440.6c2.8 0 5.5-1.8 5.5-5.5V322.5H295.4v22.2c0 12.9-10.2 22.2-22.2 22.2H199.4c-12.9 0-22.2-9.2-22.2-22.2V322.5H44.3V435.1c0 3.7 1.8 5.5 5.5 5.5H422.8zm10.5-336.2c0 3.2 2.2 5.4 5.4 7.5l64.6 25.8 25.8 64.6c2.2 3.2 4.3 5.4 8.6 5.4c3.2 0 5.4-2.2 7.5-5.4l26.9-64.6L635.7 112c3.2-2.2 5.4-4.3 5.4-8.6c0-3.2-2.2-5.4-5.4-7.5L572.2 68.9 545.2 5.4c-2.2-3.2-4.3-5.4-8.6-5.4c-3.2 0-5.4 2.2-7.5 5.4L503.2 68.9 438.6 95.8c-3.2 2.2-5.4 4.3-5.4 8.6z'
      
    ]
  };

  

  
  

  var faSparklingSpeechBubble = {
    prefix: 'fak',
    iconName: 'sparkling-speech-bubble',
    icon: [
      736,
      512,
      [],
      'e005',
      
      'M700.2 236c8-4 13-12 14-22c-1-9-6-17-14-21l-105-52-52-105c-8-16-35-16-43 0l-52 105-105 52c-8 4-14 12-14 22c0 9 6 17 14 21l105 52 52 105c4 8 12 14 22 14c9 0 17-6 21-14l52-105 105-52zm-64-22l-69 35c-5 2-9 6-11 11l-34 69-35-69c-2-5-6-9-11-11l-69-35 69-34c5-2 9-6 11-11l35-69 34 69c2 5 6 9 11 11l69 34zM453.7 389.2C406.7 434.9 336 464 257.2 464c-33 0-64-5-93-14c-29 21-78 46-139 46c-10 0-19-5-23-14c-3-9-2-19 5-26c1 0 32-34 46-73c-33-35-52-79-52-127c0-114 114-208 256-208C321 48 379.5 67.3 424.5 98.9l-6.1 12.2-35.6 17.6C347.8 108.2 304.2 96 257.2 96c-115 0-208 72-208 160c0 43 21 75 39 94l21 22-11 28c-5 14-12 28-20 40c24-8 44-19 58-29l19-14 23 7c25 8 52 12 79 12c72.4 0 136.7-28.6 174-72.3l22.5 45.5zM337.3 328c8 0 16-8 16-16V296c0-9-8-16-16-16h-192c-9 0-16 7-16 16v16c0 8 7 16 16 16h192zm-64-96c8 0 16-8 16-16V200c0-9-8-16-16-16h-128c-9 0-16 7-16 16v16c0 8 7 16 16 16h128z'
      
    ]
  };

  

  
  

  var faUserFriends = {
    prefix: 'fak',
    iconName: 'user-friends',
    icon: [
      633,
      512,
      [],
      'e002',
      
      'M407.3 313.9l71.1 0c7.7 0 15.3 .6 22.6 1.7c28.3 4.4 53.5 16.8 74.5 34.7c27.9 23.4 47.1 56.4 53 93.7c.2 1.4 .4 2.8 .6 4.2c.9 6.9 .9 13.9 .9 20.8c0 13.3-10.1 24.1-22.9 25.1c-.6 0-1.2 .1-1.8 .1l-134.2 0c4.3-8.1 6.8-17.4 6.8-27.3l0-.6c0-1 0-2.1 0-3.2c0-3.5-.1-7.5-.3-11.6l43.9-1 63.8 0c-2.2-13.6-6.9-26.3-13.6-37.8c-1.2-2-2.4-3.9-3.7-5.9c-5.8-8.6-12.7-16.3-20.6-22.9l-.3-.3c-14.4-12.3-31.2-20.8-49.7-24.2l-.1 0c0 0 0 0 0 .1l-.1 0c-9.8-1.2-18.1-1.7-25.7-1.8c-2 0-4 0-5.9 0c-1.1 0-2.2 0-3.4 .1c-4.8 .1-9.4 .4-14.1 .8c-.5 0-1 .1-1.5 .1l-.6-.9c0 0 0 0 0-.1c-2-3-4-5.9-6.1-8.8c-9.3-12.7-20.1-24.2-32.2-34.3l-.7-.6zM388.5 198.8c-2.3-7.3-3.5-15.1-3.5-23.1c0-16.1 4.9-31 13.2-43.4c1.3-2 2.8-3.9 4.3-5.8C416.8 109.1 438.3 98 462.5 98c42.8 0 77.5 34.7 77.5 77.6s-34.7 77.6-77.5 77.6c-34.7 0-64.1-22.9-74-54.4zm74 10.8a33.9 33.9 0 1 0 0-67.8 33.9 33.9 0 1 0 0 67.8zM28.6 444.2c5.7-42.4 27.5-80.1 59.7-106.5c29.4-24.5 67.3-39.6 108.1-39.6h86.3c41.7 0 78.7 15.1 108.1 39.6c32.2 26.4 54 64.1 59.7 106.5c.9 7.5 .9 15.1 .9 22.6c0 15.1-12.3 27.3-27.5 27.3H55.2c-15.2 0-27.5-12.3-27.5-27.3c0-7.5 0-15.1 .9-22.6zm90.1-312c0-42.4 22.8-82 60.7-103.7c37-21.7 83.4-21.7 121.3 0c37 21.7 60.7 61.3 60.7 103.7c0 43.4-23.7 82.9-60.7 104.6c-37.9 21.7-84.4 21.7-121.3 0c-37.9-21.7-60.7-61.3-60.7-104.6zm197.2 0c0-26.4-15.2-50.9-37.9-65c-23.7-13.2-53.1-13.2-75.8 0c-23.7 14.1-37.9 38.6-37.9 65c0 27.3 14.2 51.8 37.9 66c22.7 13.2 52.1 13.2 75.8 0c22.8-14.1 37.9-38.6 37.9-66zM196.4 343.3c-45.5 0-85.3 24.5-106.2 60.3c-8.5 14.1-14.2 29.2-16.1 45.2H405c0-1.9 0-4.7-.9-7.5c-2.8-13.2-7.6-25.4-15.2-37.7c-20.9-35.8-60.7-60.3-106.2-60.3H196.4z'
      
    ]
  };

  

  
  

  var faUsers = {
    prefix: 'fak',
    iconName: 'users',
    icon: [
      640,
      512,
      [],
      'e000',
      
      'M557.6 236.2c-45.3 0-80.6-35.1-80.6-80.1c0-44.1 35.2-80.1 80.6-80.1c44.3 0 80.6 36.1 80.6 80.1c0 45.1-36.3 80.1-80.6 80.1zm0-112.2c-18.1 0-32.2 15-32.2 32c0 18 14.1 32 32.2 32c17.1 0 32.2-14 32.2-32c0-17-15.1-32-32.2-32zm-9.4 148.7c46.1-4.6 88 29.4 91.6 75.4c1.4 14-7.6 24.9-21.6 26.3c-13 1.3-25.1-7.6-26.5-21.5c-1.9-18.9-19.7-34.3-39.7-32.3L528 323c-4 .4-7.8 2.8-11.7 4.2c-10.4-13-23.7-23.8-37.7-32.5c12.1-10.3 27.5-17.9 45.6-19.7l24.1-2.4zM82.4 236.2c45.3 0 80.6-35.1 80.6-80.1C162.9 112 127.7 76 82.4 76C38.1 76 1.8 112 1.8 156.1c0 45.1 36.3 80.1 80.6 80.1zm0-112.2c18.1 0 32.2 15 32.2 32c0 18-14.1 32-32.2 32c-17.1 0-32.2-14-32.2-32c0-17 15.1-32 32.2-32zm9.4 148.7c-46.1-4.6-88 29.4-91.6 75.4c-1.4 14 7.6 24.9 21.6 26.3c13 1.3 25.1-7.6 26.5-21.5C50.2 334 67.9 318.6 88 320.6L112 323c4 .4 7.8 2.8 11.7 4.2c10.4-13 23.7-23.8 37.7-32.5c-12.1-10.3-27.5-17.9-45.6-19.7l-24.1-2.4zm3.6 186.2c6-45.1 29.2-85.1 63.5-113.2c31.2-26 71.5-42.1 114.8-42.1h91.7c44.3 0 83.6 16 114.8 42.1c34.2 28 57.4 68.1 63.4 113.2c1 8 1 16 1 24c0 16-13.1 29-29.2 29H123.6c-16.1 0-29.2-13-29.2-29c0-8 0-16 1-24zm95.7-331.5c0-45.1 24.2-87.1 64.5-110.2c39.3-23 88.6-23 128.9 0c39.3 23 64.5 65.1 64.5 110.2c0 46.1-25.2 88.1-64.5 111.2c-40.3 23-89.6 23-128.9 0c-40.3-23-64.5-65.1-64.5-111.2zm209.5 0c0-28-16.1-54.1-40.3-69.1c-25.2-14-56.4-14-80.6 0c-25.2 15-40.3 41.1-40.3 69.1c0 29 15.1 55.1 40.3 70.1c24.2 14 55.4 14 80.6 0c24.2-15 40.3-41.1 40.3-70.1zM273.7 351.8c-48.3 0-90.6 26-112.8 64.1c-9.1 15-15.1 31-17.1 48.1H495.2c0-2 0-5-1-8c-3-14-8.1-27-16.1-40.1c-22.2-38.1-64.5-64.1-112.8-64.1H273.7z'
      
    ]
  };

  



export {

  faLinkEmbed,
  

  faLinkPill,
  

  faLinkText,
  

  faPrivate,
  

  faRecord,
  

  faRecordSlash,
  

  faSalesforce,
  

  faSalesforceOutline,
  

  faSparklingBriefcase,
  

  faSparklingSpeechBubble,
  

  faUserFriends,
  

  faUsers,
  

};
